import { Grid, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

import { faFileCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SolidButton, StyledHeader, StyledParagraph } from './styles';
import { useCanFileFnolClaim } from '../../claims/fnol/useCanFileFnolClaim';
import {
  fnolNewClaimPath,
  FNOL_CLAIMS_LIST_PATH,
} from '../../claims/fnol/fnolPaths';

export const FileClaim = () => {
  const theme = useTheme();
  // This tile only ever renders on the policyholder dashboard, so the persona is always
  // insured -- the same gate the Claims button and the routes use, so widening or narrowing
  // web intake eligibility only has to happen in one place.
  const { canFileFnolClaim } = useCanFileFnolClaim(true);
  const fileClaimHref = canFileFnolClaim
    ? fnolNewClaimPath()
    : FNOL_CLAIMS_LIST_PATH;
  return (
    <Grid container columnSpacing={2} rowSpacing={2}>
      <Grid
        item
        md={3}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <FontAwesomeIcon
          icon={faFileCircleExclamation}
          size="4x"
          color={theme.palette.common.gunmetalBlue}
        />
      </Grid>
      <Grid item md={9}>
        <StyledHeader>File a Claim/Updates</StyledHeader>
        <StyledParagraph>
          You can also file a claim by calling 1 (833) MEET MOO and our support
          team will be ready to assist you
        </StyledParagraph>
        <Link style={{ display: 'block' }} to={fileClaimHref}>
          <SolidButton
            type="submit"
            sx={{ marginTop: '1rem', width: '100% !important' }}
          >
            File a Claim/Updates
          </SolidButton>
        </Link>
      </Grid>
    </Grid>
  );
};
